import { useEffect } from 'react';
import { currentAuthHeaders } from '@/api/client';
import { useAuthStore } from '@/stores/auth';

declare global {
  interface Window {
    /** Read by the framed opmeting page (portal-meten meten.html `srv()`). */
    metenAuth?: () => Promise<Record<string, string>>;
  }
}

/**
 * The opmeting tool (portal-meten/, ADR-101), framed as-is.
 *
 * The page is served by the portal's own API at /api/meten/, so it is
 * same-origin with this view and asks `window.metenAuth` for the login headers
 * on every request. The server takes the person from that login; `who` here
 * only fills the name field.
 */
export function OpmetingView() {
  const email = useAuthStore((s) => s.user?.email ?? '');

  useEffect(() => {
    window.metenAuth = currentAuthHeaders;
    return () => {
      delete window.metenAuth;
    };
  }, []);

  const who = email.split('@')[0];
  const src = `/api/meten/${who ? `?${new URLSearchParams({ who })}` : ''}`;

  return (
    <iframe
      title="Opmeting"
      src={src}
      className="block w-full border-0 bg-white h-[calc(100vh-56px)] lg:h-[calc(100vh-80px)]"
    />
  );
}
